import { app } from './Api'

const get_relatorio = async (page,qtd,order,th,empresa_id,data_inicial,data_final,data_atual) => {
    return app.get(`relatorio?page=${page}&order=${order}&qtd=${qtd}&th=${th}&empresa_id=${empresa_id}&data_inicial=${data_inicial}&data_final=${data_final}&data_atual=${data_atual}`)
}

export { get_relatorio }